export default {
  // TODO: [PAYIN-3693] Change translations key id to a generic one.
  securityCodeHelpButton: {
    id: 'adyen_card_payment_method_security_code_help_button',
    defaultMessage: 'What is the CVV?',
  },
}
